export const CLOSE_ERROR_NOTIFICATION = "CLOSE_ERROR_NOTIFICATION"
export const NOTIFICATION_ERROR_MESSAGE = "NOTIFICATION_ERROR_MESSAGE"

export const CLOSE_SUCCESS_NOTIFICATION = "CLOSE_SUCCESS_NOTIFICATION"
export const NOTIFICATION_SUCCESS_MESSAGE = "NOTIFICATION_SUCCESS_MESSAGE"
